<template>
  <!-- <div v-if="frombrother" class="mt-3 alert alert-secondary" v-html="frombrother"></div> -->
  <div>
    <h3 style="text-align: center" class="py-1">
      {{ this.datescope }}新增{{ this.categoryLabel }}文献
    </h3>
    <div style="text-align: center">(更新于{{ this.currentDate }})</div>
    <b-table
      :items="getCurrentPageItems()"
      :fields="fields"
      striped
      responsive="sm"
    >
      <template #cell(index)="row">
        {{ getRowIndex(row.item) }}
      </template>

      <template #cell(show_details)="row">
        <b-button
          @click="showdetails(getRowIndex(row.item) - 1)"
          v-b-modal.modal-xl
          ><icon name="eye"></icon
        ></b-button>
      </template>
    </b-table>
    <div class="overflow-auto">
      <b-pagination-nav
        v-model="currentPage"
        :number-of-pages="totalPages"
        :per-page="perPage"
        align="center"
        size="sm"
        base-url="#"
      ></b-pagination-nav>
    </div>
    <b-modal id="modal-xl" size="xl" title="文献信息">
      <b-table
        stacked
        :items="seldata"
        v-show="showflag"
        style="background-color: white"
      >
      </b-table>
    </b-modal>
  </div>
</template>

<script>
import { eventBus } from "../main";
export default {
  name: "LiteratureIntro",
  data() {
    return {
      selected: "",
      currentDate: "",
      perPage: 10,
      seldata: [],
      showflag: "",
      contents: [],
      docName: "battery",
      thecardtitle: "Child Component!",
      frombrother: "",
      currentPage: 1,
      category: [
        { key: "battery", label: "电池" },
        { key: "superconductor", label: "超导" },
        { key: "topological", label: "拓扑" },
        { key: "quantumcomputating", label: "量子计算" },
      ],
      fields: [
        { key: "index", label: "序号" },
        { key: "journal", label: "期刊名称" },
        { key: "title", label: "论文题目" },
        { key: "show_details", label: "查看细节" },
      ],
    };
  },
  watch: {
    $route(to, from) {
      this.fetchData();
    },
    // currentPage() {
    //   // 在 currentPage 改变时，更新 URL 中的查询参数，以便用户刷新页面后能够保持当前页
    //   this.$router.replace({ query: { page: this.currentPage } });
    // },
  },
  mounted() {
    eventBus.$on("selected", (message) => {
      this.selected = message;
      // console.log(this.selected)

      if (this.$route.params.id) {
        if (this.$route.params.id == "newest") {
          this.docName = "battery";
        } else {
          this.docName = this.$route.params.id.split("-")[1];
          this.selected = this.$route.params.id.split("-")[0];
        }
        // console.log('docname is' + this.docName)
        let wos_url =
          "/static/literaturejson/" +
          this.selected +
          "/wos/" +
          this.docName +
          ".json";
        let arxiv_url =
          "/static/literaturejson/" +
          this.selected +
          "/arxiv/" +
          this.docName +
          ".json";
        this.$http.get(wos_url).then(
          (res) => {
            this.contents = Array.from(Object.values(res.data));
            // console.log(Array.isArray(this.contents));
            this.$http.get(arxiv_url).then((res) => {
              // this.contents=Array.from(Object.values(res.data))
              this.contents = this.contents.concat(
                Array.from(Object.values(res.data))
              );
            });
          },
          (reason) => {
            // console.log('reason' + reason)
            this.$router.push({ path: "/404" });
          }
        );
        // this.$http.get(arxiv_url).then(
        //   (res) => {
        //     // this.contents=Array.from(Object.values(res.data))
        //     this.contents = this.contents.concat(
        //       Array.from(Object.values(res.data))
        //     );
        //   }
          // (reason) => {
          //   // console.log('reason' + reason)
          //   this.$router.push({ path: "/404" });
          // }
        // );
      }
    });
  },
  computed: {
    totalPages() {
      if (this.contents.length > 1) {
        // console.log(Math.ceil(this.contents.length / this.perPage));
        return Math.ceil(this.contents.length / this.perPage);
      } else {
        return 1;
      }
    },
    datescope() {
      if (this.selected) {
        let dateString = this.selected;
        var year = dateString.substr(0, 4);
        var month = dateString.substr(4, 2) - 1; // 月份从0开始，需要减1
        var day = dateString.substr(6, 2);
        var date = new Date(year, month, day);
        this.currentDate =
          year + "年" + dateString.substr(4, 2) + "月" + day + "日";
        // 获取7天前的日期
        var previousDate = new Date(date.getTime() - 7 * 24 * 60 * 60 * 1000);
        // 格式化日期为 YYYYMMDD 格式
        var formattedDate =
          previousDate.getFullYear() +
          "年" +
          padZero(previousDate.getMonth() + 1) +
          "月" +
          padZero(previousDate.getDate()) +
          "日";

        // 辅助函数：在单个数字前添加零以保持两位数的格式
        function padZero(num) {
          return num.toString().padStart(2, "0");
        }
        // console.log(this.currentDate); // 输出：20031002
        return formattedDate + "-" + this.currentDate;
      }
    },
    categoryLabel() {
      console.log(this.docName);
      this.currentPage = 1;
      const item = this.category.find(
        (category) => category.key == this.docName
      );
      return item ? item.label : "";
    },
  },
  methods: {
    fetchData() {
      // eventBus.$on('selected', (message) => {
      //     this.selected = message;
      //     console.log(this.selected)
      // });
      console.log(this.$route.params.id);
      if (this.$route.params.id) {
        // console.log(this.$route.params.id)
        if (this.$route.params.id != "newest") {
          this.docName = this.$route.params.id.split("-")[1];
          this.selected = this.$route.params.id.split("-")[0];
          let wos_url =
            "/static/literaturejson/" +
            this.selected +
            "/wos/" +
            this.docName +
            ".json";
          let arxiv_url =
            "/static/literaturejson/" +
            this.selected +
            "/arxiv/" +
            this.docName +
            ".json";
          this.$http.get(wos_url).then(
            (res) => {
              this.contents = Array.from(Object.values(res.data));
              // console.log(Array.isArray(this.contents));
              this.$http.get(arxiv_url).then((res) => {
              // this.contents=Array.from(Object.values(res.data))
              this.contents = this.contents.concat(
                Array.from(Object.values(res.data))
              );
            });
            },
            (reason) => {
              // console.log('reason' + reason)
              this.$router.push({ path: "/404" });
            }
          );
          // this.$http.get(arxiv_url).then(
          //   (res) => {
          //     // this.contents=Array.from(Object.values(res.data))
          //     this.contents = this.contents.concat(
          //       Array.from(Object.values(res.data))
          //     );
          //   },
          //   (reason) => {
          //     // console.log('reason' + reason)
          //     this.$router.push({ path: "/404" });
          //   }
          // );
        } else {
          this.docName = "battery";
          let wos_url =
            "/static/literaturejson/" +
            this.selected +
            "/wos/" +
            this.docName +
            ".json";
          let arxiv_url =
            "/static/literaturejson/" +
            this.selected +
            "/arxiv/" +
            this.docName +
            ".json";
          this.$http.get(wos_url).then(
            (res) => {
              this.contents = Array.from(Object.values(res.data));
              // console.log(Array.isArray(this.contents));
            },
            (reason) => {
              // console.log('reason' + reason)
              this.$router.push({ path: "/404" });
            }
          );
          this.$http.get(arxiv_url).then(
            (res) => {
              // this.contents=Array.from(Object.values(res.data))
              this.contents = this.contents.concat(
                Array.from(Object.values(res.data))
              );
            },
            (reason) => {
              // console.log('reason' + reason)
              this.$router.push({ path: "/404" });
            }
          );
        }
      }
    },
    showdetails(index) {
      this.showflag = true;
      this.seldata = [this.contents[index]];
      // console.log(this.seldata);
    },
    getCurrentPageItems() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      // console.log(this.testdata.slice(start, end));
      return this.contents.slice(start, end);
    },
    handlePageChange(page) {
      this.$router.push({ query: { page } });
    },
    getRowIndex(item) {
      const index = this.contents.indexOf(item);
      return index !== -1 ? index + 1 : "";
    },
  },
};
</script>

<style scoped>
.table {
  background-color: rgb(241, 234, 224) !important;
}
.custom-header-cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
